import { createAsyncThunk } from '@reduxjs/toolkit';
import { CreateAnswerRequest } from 'domain/question';
import { answerApi } from 'question/api';

// The skipped round's multiple-choice answers. Its perspectives were saved as they were written.
export const submitAnswers = createAsyncThunk<void, CreateAnswerRequest[]>(
  'question/postAnswers',
  async (answers, { dispatch }) => {
    answers.forEach((answer) => {
      dispatch(answerApi.endpoints.postAnswer.initiate(answer));
    });
  }
);
